import {gql} from "graphql-request";

export const GetCountry = gql`
  query GetCountry($id:ID!) {
    country(id: $id) {
      name
      trailsCount
      impressionsCount
      boundingBox
      reviewsCount
      polygon {
        id
        boundingPolygon
      }
    }
  }
`;

// The full country list for the signup Country step. Mirrors what the mobile
// apps fetch (Android's User.graphql asks for `countries { id name code3l code2l }`)
// so web offers the same choices. ~350 rows, so it's fetched once and filtered
// client-side rather than round-tripping on every keystroke.
export const GetCountries = gql`
  query GetCountries {
    countries {
      id
      name
      code3l
      code2l
      countryId
    }
  }
`;
